import { RecommendationFacade } from './RecommendationFacade';

/**
 * Instância singleton do serviço de recomendação
 * Usa o padrão Facade para ocultar a complexidade da implementação
 * e apresentar uma interface unificada para recomendações.
 */
export const recommendationService = new RecommendationFacade();

/**
 * Exporta a classe RecommendationFacade para casos onde
 * é necessário criar instâncias personalizadas com injeção
 * de dependências específicas.
 */
export { RecommendationFacade }; 